query ListApprovalTags($id: UUID!) {
  userApproval(id: $id) {
    id
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _createdDate
        createdByUser
        _rowTimestamp
      }
    }
  }
}
